import React, { useEffect } from "react";
import HoverMenu from "material-ui-popup-state/HoverMenu";
import MenuItem from "@material-ui/core/MenuItem";
import { Avatar, Button, Typography, useMediaQuery } from "@material-ui/core";
import classes from "@css/components/website/Header.module.css";
import history from "../../history";
import { ArrowDropDownOutlined } from "@material-ui/icons";
import { usePopupState, bindHover, bindMenu } from "material-ui-popup-state/hooks";
import { KustomerLauncher } from "../KustomerLauncher";
import { useSelector } from "react-redux";
import { roles } from "../../constants/roles";
import { getInitials } from "../../helpers/profile";
import { segmentTrack } from "../../helpers/segment";

function HeaderMenuItem({
  name,
  menuItems,
  isOpaque,
  icon,
  chipText,
  linkTo,
  extended = false,
}: {
  name: string;
  menuItems?: Array<any>;
  isOpaque: boolean;
  icon?: string;
  chipText?: string;
  linkTo?: string;
  extended?: boolean;
}) {
  const isMobile = useMediaQuery("(max-width:1369px)");

  const isLoggedIn = useSelector((state: any) => state.firebase.auth?.uid);
  const profile = useSelector((state: any) => state.firebase.profile);
  const isCustomer = isLoggedIn && profile?.userType === roles.customer.value;
  const nameInitials = isLoggedIn && profile && isCustomer && getInitials(profile?.fullName);

  const popupState = usePopupState({
    variant: "popover",
    popupId: "headerMenu",
  });

  useEffect(() => {
    if (isMobile) {
      popupState.close();
    }
  }, [isMobile]);

  const handleItemClick = (item: any) => {
    segmentTrack("Header Menu Item Clicked", { item: item.label, link: item.link });
    item.func ? item.func() : item.link ? (item.isOutsideLink || item.requiresRefresh ? window.open(item.link) : history.push(item.link)) : null;
    popupState.close();
  };

  const Icon = ({ isOpen }: { isOpen?: boolean }) => {
    const openStyles = isOpen ? { transform: "rotate(-180deg)" } : {};
    return <ArrowDropDownOutlined style={{ ...openStyles }} htmlColor={isOpaque ? "black" : "white"} />;
  };

  const Chip = () => (
    <div className={classes.chipOuter}>
      <Typography className={classes.chipText}>{chipText}</Typography>
    </div>
  );

  const menuItemsByColumn = menuItems?.reduce((acc: any, item: any) => {
    if (item.column) {
      if (!acc[item.column]) {
        acc[item.column] = [];
      }
      acc[item.column].push(item);
    }
    return acc;
  }, {});

  return (
    <div style={{ position: chipText ? "relative" : undefined }}>
      <div>
        <Button
          disableRipple
          className={icon && !isCustomer ? classes.menuIconButton : icon && isCustomer ? classes.menuAvatarButton : classes.menuButton}
          style={{ color: isOpaque ? "black" : "white" }}
          {...bindHover(popupState)}
        >
          {icon && !isCustomer && <img src={icon} />}
          {icon && isCustomer && <Avatar className={classes.userAvatar}>{nameInitials}</Avatar>}
          {name && linkTo && (linkTo?.length > 0 || linkTo === "undefined") ? <span onClick={() => history.push(linkTo)}>{name}</span> : name}
          {menuItems && menuItems?.length > 0 && <Icon isOpen={popupState.isOpen} />}
        </Button>
        {menuItems && menuItems?.length > 0 && (
          <HoverMenu
            {...bindMenu(popupState)}
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            transformOrigin={{ vertical: "top", horizontal: "left" }}
            classes={{ paper: classes.menuDropdown }}
          >
            {extended && (
              <div className={classes.extendedMenu}>
                {Object.keys(menuItemsByColumn).map((column) => (
                  <div key={column}>
                    {menuItemsByColumn[column].map((item: any) => (
                      <div className={classes.menuItemParent} key={item.label}>
                        <MenuItem className={classes.menuItem} key={item.label} onClick={() => handleItemClick(item)}>
                          {item.label}
                        </MenuItem>
                        {item.subLinks && (
                          <div className={classes.menuSubLinks}>
                            {item.subLinks.map((subLink: any) => (
                              <MenuItem className={classes.subMenuItem} key={subLink.label} onClick={() => handleItemClick(subLink)}>
                                {subLink.label}
                              </MenuItem>
                            ))}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            )}
            {!extended &&
              menuItems?.map((item) => (
                <MenuItem className={classes.menuItem} key={item.label} onClick={() => handleItemClick(item)}>
                  {item.icon && item.icon}
                  <span style={{ marginLeft: item.icon ? "16px" : "0" }}>
                    {!item.link ? <KustomerLauncher>{item.label}</KustomerLauncher> : item.label}{" "}
                  </span>
                </MenuItem>
              ))}
          </HoverMenu>
        )}
      </div>
      {chipText && <Chip />}
    </div>
  );
}

export default HeaderMenuItem;
